import { DEFAULT_IMAGEM_PERFIL } from '@/modules/var';
import { getNomeSobrenome } from './getNomeSobrenome';

function getDadosGraficoOrganizacional(unidade) {
  return {
    organization: {
      dados: [
        [unidade.sigla + unidade.id],
        ...unidade.servidores.map((s) => [unidade.sigla + unidade.id, s.id]),
      ],
      nos: [
        {
          id: unidade.sigla + unidade.id,
          name: unidade.sigla,
          title: (unidade.gestor ? getNomeSobrenome(unidade.gestor.nome) : 'N/D'),
          image: DEFAULT_IMAGEM_PERFIL,
          info: `<span style="color:#2D5269;font-weight:bold">${unidade.nome} (${unidade.sigla})`
            + '</span><br/>'
            + `<span style="color:#348ECA;font-weight:bold">GESTOR:</span> ${
              unidade.gestor ? getNomeSobrenome(unidade.gestor.nome) : 'N/D'}<br>`
            + `<span style="color:#348ECA;font-weight:bold">FUNÇÃO:</span> ${
              unidade.gestor && unidade.gestor.funcao ? unidade.gestor.funcao : 'N/D'}<br/>`
            + `<span style="color:#348ECA;font-weight:bold">CARGO:</span> ${
              unidade.gestor && unidade.gestor.cargo ? unidade.gestor.cargo : 'N/D'}<br/>`
            + `${unidade.gestorSubstituto ? `<span style="color:#00ABA4;font-weight:bold">GESTOR SUBSTITUTO:</span>
              ${getNomeSobrenome(unidade.gestorSubstituto.nome)}` : ''}`,
          isGestor: true,
        },
        ...unidade.servidores.map((s) => ({
          id: s.id,
          name: getNomeSobrenome(s.nome),
          image: DEFAULT_IMAGEM_PERFIL,
          info: `<span style="color:#2D5269;font-weight:bold">${getNomeSobrenome(s.nome)}</span><br/>`
            + `<span style="color:#348ECA;font-weight:bold">FUNÇÃO:</span> ${s.funcao ? s.funcao : 'N/D'}<br/>`
            + `<span style="color:#348ECA;font-weight:bold">CARGO:</span> ${s.cargo ? s.cargo : 'N/D'}`,
          isGestor: false,
        })),
      ],
    },
    loaded: true,
  };
}

export default getDadosGraficoOrganizacional;
